export default __webpack_public_path__ + "static/media/result_body_emaciated.f9918164.jpg";